module.exports = require("eth-lib/lib/hash");